import { Airport } from "@/models/airport";
import { t } from "i18next";

const milesBetweenToPoints = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d / 1.609;
};

const deg2rad = (deg: number): number => {
  return deg * (Math.PI / 180);
};

export const getDistance = (
  guessAirport: Pick<Airport, "lat" | "lon">,
  correctAirport: Pick<Airport, "lat" | "lon">
): number => {
  return Math.round(
    milesBetweenToPoints(
      guessAirport.lat,
      guessAirport.lon,
      correctAirport.lat,
      correctAirport.lon
    )
  );
};

export const descriptionForDistance = (distance: number): string => {
  var distanceDescription = `${t(
    "game.distance.guessWas.cold"
  )} (${roundDistance(distance)} ${t("game.roundSummary.distanceUnit")})`;

  if (distance < 0) {
    distanceDescription = `${t("game.distance.guessWas.cold")} (${roundDistance(
      distance
    )} ${t("game.roundSummary.distanceUnit")})`;
  } else if (distance <= 100) {
    distanceDescription = `${t("game.distance.guessWas.hot")} (${roundDistance(
      distance
    )} ${t("game.roundSummary.distanceUnit")})`;
  } else if (distance <= 500) {
    distanceDescription = `${t("game.distance.guessWas.warm")} (${roundDistance(
      distance
    )} ${t("game.roundSummary.distanceUnit")})`;
  }

  return distanceDescription;
};

export const stateForDistance = (
  distance: number
): "cold" | "warm" | "hot" | "default" => {
  let state: "cold" | "warm" | "hot" | "default" = "cold";

  if (distance < 0) {
    state = "cold";
  } else if (distance <= 100) {
    state = "hot";
  } else if (distance <= 500) {
    state = "warm";
  }

  return state;
};

export const roundDistance = (distance: number): string => {
  return (Math.round(distance / 10) * 10).toLocaleString(navigator.language);
};
